"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useDisableBodyScroll: function() {
        return _useDisableBodyScroll.useDisableBodyScroll;
    },
    useFocusFirstElement: function() {
        return _useFocusFirstElement.useFocusFirstElement;
    }
});
const _useDisableBodyScroll = require("./useDisableBodyScroll");
const _useFocusFirstElement = require("./useFocusFirstElement");
